import * as Styled from "./CatalogItemsCount.styled"

export function CatalogItemsCountSkeleton(props) {

    return <Styled.CatalogItemsCountSkeleton {...props} />
}